import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=c08245a6&scoped=true&"
import script from "./resetPassword.vue?vue&type=script&lang=babel&"
export * from "./resetPassword.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08245a6",
  null
  
)

export default component.exports